export default {
  baseUrl: process.env.VUE_APP_API_URL,

  observer:[],

  addobserver: function(o) {
    this.observer.push(o);
  },

  request: function(ctrl,url,action,method,body,cb_success,rtype,noerror) {
    // info to observer
    this.observer.forEach(o => {
      if (o.cfgStartLoad) o.cfgStartLoad();
    });
    // config request
    var rcfg = { credentials: 'include', method: method }
    if (body) rcfg.body = body;
    // send request
    var self = this;
    fetch(url,rcfg).then(function(resp) {
      // info to observer
      self.observer.forEach(o => {
        if (o.cfgStopLoad) o.cfgStopLoad();
      });
      // check response
      if (resp.status > 290) {
        var title = 'Fehler';
        if (resp.status >= 500) title = 'Server-Fehler';
        if (noerror) return;
        resp.text().then(function(text) {
          ctrl.$bvToast.toast(action + ' (' + resp.status + ') ' + text,{title:title,variant:"danger"});
        });
      } else {
        if (rtype == 'text') {
          resp.text().then(cb_success);
        } else if (rtype == 'blob') {
          resp.blob().then(cb_success);
        } else {
          resp.json().then(cb_success);
        }
      }
    });
  },

  get: function(ctrl,url,action,cb_success,text,noerror) {
    this.request(ctrl,url,action,'GET',false,cb_success,text,noerror);
  },

  post: function(ctrl,url,action,body,cb_success,text,noerror) {
    this.request(ctrl,url,action,'POST',body,cb_success,text,noerror);
  },

  put: function(ctrl,url,action,body,cb_success) {
    this.request(ctrl,url,action,'PUT',body,cb_success);
  },

  delete: function(ctrl,url,action,cb_success) {
    this.request(ctrl,url,action,'DELETE',false,cb_success);
  },

  loadcfg: function(props,ctrl,cb_success) {
    this.get(ctrl,this.baseUrl + 'rest/config/base?set=' + encodeURIComponent(JSON.stringify(props)),'Konfiguration laden',cb_success);
  },

  savecfg: function(props,ctrl,cb_success) {
    this.post(ctrl,this.baseUrl + 'rest/config/base','Konfiguration speichern',JSON.stringify(props),cb_success);
  },

  listFirmConfig(ctrl,start,count,catid,cb) {
    var url = this.baseUrl + 'rest/config/firm/?start=' + start + '&count=' + count;
    if (catid && catid > 0) {
      url += '&cat=' + catid;
    }
    this.get(ctrl,url,'Konfiguration laden',cb);
  },

  saveFirmConfig(ctrl,item,cb) {
    this.post(ctrl,this.baseUrl + 'rest/config/firm/','Konfiguration speichern',JSON.stringify(item),cb);
  },

  deleteFirmConfig(ctrl,id,cb) {
    this.delete(ctrl,this.baseUrl + 'rest/config/firm/' + encodeURIComponent(id),'Konfiguration löschen',cb);
  },

  checkSmbEnabled(ctrl,cb) {
    this.loadcfg(["proxy.smbenabled"],ctrl,function(data) {
      console.log(data);
      var test = String(data["proxy.smbenabled"]);
      cb(test.startsWith('1') || test.startsWith('t'));
    });
  },

  listSystemTables() {
    return fetch(this.baseUrl + 'rest/datamap/jsontypes');
  }

}
